export enum LogType {
  INFO,
  WARNING,
  ERROR,
  REQUEST,
  RESPONSE,
}
